import {PageNotFoundComponent} from './404.component';

export const PageNotFoundRoutes = [
  {
    path: '404-page',
    component: PageNotFoundComponent,
  },
];
